// @ts-nocheck

import React, { useEffect, useRef, useState } from "react";

import { Icon } from "Components/atoms/Icon";
import { Typography } from "Components/atoms/Typography";

import { FlightsFilterWrapper, StopsFilterWrapper2 } from "./styles";
import { StopsFilter } from "Components/molecules/StopsFilter";
import { useFilterContext } from "shared/contexts/FilterContext";
import { RangeFilter } from "Components/molecules/PriceRangeFilter";
import { AirportsFilter } from "Components/molecules/AirportsFilter";
import { AirportsFilterItem } from "Components/molecules/AirportsFilter/types";
import { EntityFilter } from "Components/molecules/EntityFilter";
import { handleAirlineChange, handleSellerChange } from "../functions";
import { useSearchContext } from "shared/contexts/SearchContext";
import {
  FilterContextProps,
  FilteredFlightResultsProps,
  FlightsFilterProps,
} from "./types";

/**
 * Componente FlightsFilter
 */
export const FlightsFilter: React.FC<FlightsFilterProps> = ({
  actionFilter,
}) => {
  const {
    searchState,
    setSearchLoader,
    setStateSearchFinished,
    setSearchPercentResult,
    filteredFlightResults,
    setFilteredFlightResults,
  } = useSearchContext();

  const {
    stops,
    setStops,
    minPrice,
    setMinPrice,
    maxPrice,
    setMaxPrice,
    priceRange,
    setPriceRange,
    airportsFrom,
    setAirportsFrom,
    airportsTo,
    setAirportsTo,
    firstSectorTimeRange,
    setFirstSectorTimeRange,
    secondSectorTimeRange,
    setSecondSectorTimeRange,
    airlines,
    setAirlines,
    sellers,
    setSellers,
    anchorFilterMobile,
    setAnchorFilterMobile,
  } = useFilterContext();

  const priceRef = useRef<HTMLDivElement>(null);
  const airportsRef = useRef<HTMLDivElement>(null);
  const timesRef = useRef<HTMLDivElement>(null);
  const sellerRef = useRef<HTMLDivElement>(null);

  const [filterContextBackup, setFilterContextBackup] =
    useState<FilterContextProps>({
      stops,
      minPrice,
      maxPrice,
      airlines,
      airportsFrom,
      airportsTo,
      priceRange,
      firstSectorTimeRange,
      secondSectorTimeRange,
      sellers,
    });

  const [filteredFlightResultsBackup, setFilterContextStatusBackup] =
    useState<FilteredFlightResultsProps>();

  const stopsOptions = [
    { label: "Direto", value: 0 },
    { label: "1 Parada", value: 1 },
    { label: "2 Paradas", value: 2 },
    { label: "3+ Paradas", value: 3 },
  ];

  useEffect(() => {
    if (!filterContextBackup) {
      setFilterContextBackup({
        stops,
        minPrice,
        maxPrice,
        airlines,
        airportsFrom,
        airportsTo,
        priceRange,
        firstSectorTimeRange,
        secondSectorTimeRange,
        sellers,
      });

      setFilterContextStatusBackup({ filteredFlightResults });
    }
  }, []);

  useEffect(() => {
    if (actionFilter === "apply") {
      if (filterContextBackup) {
        const {
          priceRange,
          stops,
          airlines,
          sellers,
          airportsFrom,
          airportsTo,
          firstSectorTimeRange,
          secondSectorTimeRange,
        } = filterContextBackup;

        setPriceRange(priceRange);
        setStops(stops);
        setAirportsFrom(airportsFrom);
        setAirportsTo(airportsTo);
        setAirlines(airlines);
        setSellers(sellers);
        setFirstSectorTimeRange(firstSectorTimeRange);
        setSecondSectorTimeRange(secondSectorTimeRange);

        setFilteredFlightResults((prev) => {
          if (!prev) {
            return null;
          }

          const updated = {
            ...prev,
            appliedFilters: {
              ...prev.appliedFilters,
              priceFrom: priceRange[0],
              priceTo: priceRange[1],
              stops,
              airportsFrom: airportsFrom
                .filter((a) => a.isChecked)
                .map((a) => a.iata),
              airportsTo: airportsTo
                .filter((a) => a.isChecked)
                .map((a) => a.iata),
              airlines: airlines.filter((a) => a.isChecked).map((a) => a.id),
              sellers: sellers.filter((s) => s.isChecked).map((s) => s.id),
              firtsSectorDepartureTimeFrom: firstSectorTimeRange[0],
              firtsSectorDepartureTimeTo: firstSectorTimeRange[1],
              secondSectorDepartureTimeFrom: secondSectorTimeRange[0],
              secondSectorDepartureTimeTo: secondSectorTimeRange[1],
            },
          };

          return updated;
        });
      }
    }

    if (actionFilter === "clean") {
      setStops([0, 1, 2, 3]);
      setPriceRange([minPrice, maxPrice]);

      setAirportsFrom((prev) => prev.map((a) => ({ ...a, isChecked: false })));
      setAirportsTo((prev) => prev.map((a) => ({ ...a, isChecked: false })));

      setAirlines((prev) => prev.map((a) => ({ ...a, isChecked: false })));
      setSellers((prev) => prev.map((s) => ({ ...s, isChecked: false })));

      setFirstSectorTimeRange([0, 1439]);
      setSecondSectorTimeRange([0, 1439]);

      setFilteredFlightResults((prev) => {
        if (!prev) return null;

        return {
          ...prev,
          appliedFilters: {},
        };
      });
    }

    if (actionFilter === "clean") {
      // Em vez de desmarcar todos, marcamos todos como true
      const resetAirportsFrom = airportsFrom.map((a) => ({
        ...a,
        isChecked: true,
      }));
      const resetAirportsTo = airportsTo.map((a) => ({
        ...a,
        isChecked: true,
      }));
      const resetAirlines = airlines.map((a) => ({ ...a, isChecked: true }));
      const resetSellers = sellers.map((s) => ({ ...s, isChecked: true }));

      setStops([0, 1, 2, 3]);
      setPriceRange([minPrice, maxPrice]);
      setAirportsFrom(resetAirportsFrom);
      setAirportsTo(resetAirportsTo);
      setAirlines(resetAirlines);
      setSellers(resetSellers);
      setFirstSectorTimeRange([0, 1439]);
      setSecondSectorTimeRange([0, 1439]);

      setFilterContextBackup({
        stops: [0, 1, 2, 3],
        minPrice,
        maxPrice,
        priceRange: [minPrice, maxPrice],
        airportsFrom: resetAirportsFrom,
        airportsTo: resetAirportsTo,
        airlines: resetAirlines,
        sellers: resetSellers,
        firstSectorTimeRange: [0, 1439],
        secondSectorTimeRange: [0, 1439],
      });

      setFilteredFlightResults((prev) => {
        if (!prev) return null;

        return {
          ...prev,
          appliedFilters: {
            priceFrom: minPrice,
            priceTo: maxPrice,
            stops: [0, 1, 2, 3],
            airportsFrom: resetAirportsFrom.map((a) => a.iata),
            airportsTo: resetAirportsTo.map((a) => a.iata),
            airlines: resetAirlines.map((a) => a.id),
            sellers: resetSellers.map((s) => s.id),
            firtsSectorDepartureTimeFrom: 0,
            firtsSectorDepartureTimeTo: 1439,
            secondSectorDepartureTimeFrom: 0,
            secondSectorDepartureTimeTo: 1439,
          },
        };
      });
    }
  }, [actionFilter]);

  useEffect(() => {
    const scrollMap: Record<string, React.RefObject<HTMLDivElement>> = {
      price: priceRef,
      airports: airportsRef,
      times: timesRef,
      sellers: sellerRef,
    };

    const targetRef = scrollMap[anchorFilterMobile];

    if (targetRef?.current) {
      targetRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
      setAnchorFilterMobile("default");
    }
  }, [anchorFilterMobile, setAnchorFilterMobile]);

  const handleStopsChange = (updatedStops: number[]) => {
    setStops(updatedStops);

    setFilteredFlightResults((prev: any) => ({
      ...prev,
      appliedFilters: {
        ...prev?.appliedFilters,
        stops: updatedStops,
      },
    }));
  };

  const handlePriceChange = (values: [number, number]) => {
    setPriceRange(values);

    setFilteredFlightResults((prev: any) => ({
      ...prev,
      appliedFilters: {
        ...prev?.appliedFilters,
        priceFrom: values[0],
        priceTo: values[1],
      },
    }));
  };

  const handleAirportOriginChange = (
    updatedAirport: AirportsFilterItem,
    isChecked: boolean,
  ) => {
    const updatedAirports = airportsFrom.map((airport) =>
      airport.iata === updatedAirport.iata
        ? { ...airport, isChecked }
        : airport,
    );

    setAirportsFrom(updatedAirports);

    const selectedIATAs = updatedAirports
      .filter((a) => a.isChecked)
      .map((a) => a.iata);

    setFilteredFlightResults((prev: any) => ({
      ...prev,
      appliedFilters: {
        ...prev?.appliedFilters,
        airportsFrom: selectedIATAs,
      },
    }));
  };

  const handleAirportDestinationChange = (
    updatedAirport: AirportsFilterItem,
    isChecked: boolean,
  ) => {
    const updatedAirports = airportsTo.map((airport) =>
      airport.iata === updatedAirport.iata
        ? { ...airport, isChecked }
        : airport,
    );

    setAirportsTo(updatedAirports);

    const selectedIATAs = updatedAirports
      .filter((airport) => airport.isChecked)
      .map((airport) => airport.iata);

    setFilteredFlightResults((prev: any) => ({
      ...prev,
      appliedFilters: {
        ...prev?.appliedFilters,
        airportsTo: selectedIATAs,
      },
    }));
  };

  const handleFisrtSectorDepartureTimeChange = (values: [number, number]) => {
    setFirstSectorTimeRange(values);

    setFilteredFlightResults((prev: any) => ({
      ...prev,
      appliedFilters: {
        ...prev?.appliedFilters,
        firtsSectorDepartureTimeFrom: values[0],
        firtsSectorDepartureTimeTo: values[1],
      },
    }));
  };

  const handleSecondSectorDepartureTimeChange = (values: [number, number]) => {
    setSecondSectorTimeRange(values);

    setFilteredFlightResults((prev: any) => ({
      ...prev,
      appliedFilters: {
        ...prev?.appliedFilters,
        secondSectorDepartureTimeFrom: values[0],
        secondSectorDepartureTimeTo: values[1],
      },
    }));
  };

  return (
    <FlightsFilterWrapper>
      <StopsFilter
        stops={stopsOptions}
        selectedStops={filterContextBackup?.stops ?? [0]}
        onChange={(values) => {
          setFilterContextBackup((prev: any) => {
            const next = { ...prev, stops: values };
            return next;
          });
        }}
      />

      <div ref={priceRef}>
        <RangeFilter
          title="Preço"
          iconName="FaRegMoneyBillAlt"
          minValue={minPrice}
          maxValue={maxPrice}
          valueRange={filterContextBackup?.priceRange}
          handleValueChange={(values) => {
            setFilterContextBackup((prev: any) => {
              const next = { ...prev, priceRange: values };
              return next;
            });
          }}
          value={filterContextBackup?.priceRange}
          type="currency"
        />
      </div>

      <div ref={airportsRef}>
        <AirportsFilter
          type="origin"
          airports={filterContextBackup?.airportsFrom ?? []}
          originAirport="Partindo de"
          onChange={(updatedAirport, isChecked) => {
            if (!filterContextBackup) return;

            const updatedAirports = filterContextBackup.airportsFrom.map(
              (airport) =>
                airport.iata === updatedAirport.iata
                  ? { ...airport, isChecked }
                  : airport,
            );

            setFilterContextBackup((prev: any) => ({
              ...prev,
              airportsFrom: updatedAirports,
            }));
          }}
          onToggleAll={(isChecked) => {
            setFilterContextBackup((prev: any) => ({
              ...prev,
              airportsFrom: (prev?.airportsFrom ?? []).map((airport) => ({
                ...airport,
                isChecked,
              })),
            }));
          }}
        />

        <AirportsFilter
          type="destination"
          airports={filterContextBackup?.airportsTo ?? []}
          originAirport="Chegando em"
          onChange={(updatedAirport, isChecked) => {
            if (!filterContextBackup) return;

            const updatedAirports = filterContextBackup.airportsTo.map(
              (airport) =>
                airport.iata === updatedAirport.iata
                  ? { ...airport, isChecked }
                  : airport,
            );

            setFilterContextBackup((prev: any) => ({
              ...prev,
              airportsTo: updatedAirports,
            }));
          }}
          onToggleAll={(isChecked) => {
            setFilterContextBackup((prev: any) => ({
              ...prev,
              airportsTo: (prev?.airportsTo ?? []).map((airport) => ({
                ...airport,
                isChecked,
              })),
            }));
          }}
        />
      </div>

      <div ref={timesRef}>
        <RangeFilter
          title="Horário de ida"
          iconName="LuArrowUpRight"
          minValue={0}
          maxValue={1439}
          valueRange={filterContextBackup?.firstSectorTimeRange}
          handleValueChange={(values) => {
            setFilterContextBackup((prev: any) => ({
              ...prev,
              firstSectorTimeRange: values,
            }));
          }}
          value={filterContextBackup?.firstSectorTimeRange}
          type="time"
        />

        <RangeFilter
          title="Horário de volta"
          iconName="LuArrowDownLeft"
          minValue={0}
          maxValue={1439}
          valueRange={filterContextBackup?.secondSectorTimeRange}
          handleValueChange={(values) => {
            setFilterContextBackup((prev: any) => ({
              ...prev,
              secondSectorTimeRange: values,
            }));
          }}
          value={filterContextBackup?.secondSectorTimeRange}
          type="time"
        />
      </div>

      <EntityFilter
        entities={filterContextBackup?.airlines ?? []}
        title="Companhias Aéreas"
        iconName="MdOutlineAirlines"
        onChange={(updatedAirline, isChecked) => {
          if (!filterContextBackup) return;

          const updatedAirlines = filterContextBackup.airlines.map((airline) =>
            airline.id === updatedAirline.id
              ? { ...airline, isChecked }
              : airline,
          );

          setFilterContextBackup((prev: any) => ({
            ...prev,
            airlines: updatedAirlines,
          }));
        }}
        onToggleAll={(isChecked) => {
          setFilterContextBackup((prev: any) => ({
            ...prev,
            airlines: (prev?.airlines ?? []).map((airline) => ({
              ...airline,
              isChecked,
            })),
          }));
        }}
      />

      <div ref={sellerRef}>
        <EntityFilter
          entities={filterContextBackup?.sellers ?? []}
          title="Vendedores"
          iconName="LuTicket"
          onChange={(updatedSeller, isChecked) => {
            if (!filterContextBackup) return;

            const updatedSellers = filterContextBackup.sellers.map((seller) =>
              seller.id === updatedSeller.id
                ? { ...seller, isChecked }
                : seller,
            );

            setFilterContextBackup((prev: any) => ({
              ...prev,
              sellers: updatedSellers,
            }));
          }}
          onToggleAll={(isChecked) => {
            setFilterContextBackup((prev: any) => ({
              ...prev,
              sellers: (prev?.sellers ?? []).map((seller) => ({
                ...seller,
                isChecked,
              })),
            }));
          }}
          hasBorder={false}
        />
      </div>
    </FlightsFilterWrapper>
  );
};
